import { render, staticRenderFns } from "./Top10.vue?vue&type=template&id=dff20cda&"
import script from "./Top10.vue?vue&type=script&lang=js&"
export * from "./Top10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports